import { memo } from 'react';
import { InfiniteSlider } from '../InfiniteSlider';
import { useLanguage } from '../../contexts/LanguageContext';
import useReducedMotion from '../../hooks/useReducedMotion';

// Reviewer bulgusu #4: memoize edilmemişti — HeroSlider'ın autoplay tick'i
// (6.5sn) ve her hover/focus pause/resume state değişiminde gereksiz
// yeniden render oluyordu (TrustMarquee kendi t()/reduced değerleri
// değişmediği sürece hiçbir prop almıyor, re-render'a ihtiyacı yok).
function TrustMarquee() {
  const { t } = useLanguage();
  const reduced = useReducedMotion();
  const items = [
    t('landing2.marquee.item1'),
    t('landing2.marquee.item2'),
    t('landing2.marquee.item3'),
    t('landing2.marquee.item4'),
    t('landing2.marquee.item5'),
    t('landing2.marquee.item6'),
  ];

  return (
    <div
      className="relative border-t border-white/10 bg-black/20 landing2-marquee-fade"
      data-testid="landing2-marquee"
      aria-hidden="true"
    >
      {reduced ? (
        // WCAG 2.2.2 (Pause, Stop, Hide): prefers-reduced-motion'da otomatik
        // kayan animasyon yerine statik, kaydırmasız bir liste render edilir.
        <div className="flex flex-wrap justify-center gap-x-14 gap-y-3 py-4">
          {items.map((label, i) => (
            <span key={i} className="text-sm font-bold tracking-wider text-[#8194ad] whitespace-nowrap">
              {label}
            </span>
          ))}
        </div>
      ) : (
        <InfiniteSlider className="py-4" gap={56} duration={32}>
          {items.map((label, i) => (
            <span key={i} className="text-sm font-bold tracking-wider text-[#8194ad] whitespace-nowrap">
              {label}
            </span>
          ))}
        </InfiniteSlider>
      )}
    </div>
  );
}

export default memo(TrustMarquee);
